/** viz 補助を付ける条件（viz-protocol.md §4 手順 1）。 */
export const VIZ_USE_PATTERN = /\bviz\s*\./;

/** 補助の中の error に添える 1 行（viz-protocol.md §4）。 */
export const HELPER_CONFLICT_MESSAGE =
  '補助コードと衝突しました（`viz` や `VizKind` という名前を使っていないか確認してください）';

/** コードが viz 補助を必要とするか（`viz.` を含むか）。 */
export function usesViz(userCode: string): boolean {
  return VIZ_USE_PATTERN.test(userCode);
}

/**
 * ユーザーコードの末尾に viz 補助を連結する（viz-protocol.md §4）。
 * `viz.` を含まなければ userCode をそのまま返す（userLineCount は改行を補った後の行数）。
 */
export function attachVizHelper(
  userCode: string,
  helper: string,
): { code: string; userLineCount: number; attached: boolean } {
  if (!usesViz(userCode)) {
    return {
      code: userCode,
      userLineCount: countNewlines(ensureNewline(userCode)),
      attached: false,
    };
  }
  const body = ensureNewline(userCode);
  return { code: body + '\n' + helper, userLineCount: countNewlines(body), attached: true };
}

function ensureNewline(s: string): string {
  return s.endsWith('\n') ? s : s + '\n';
}

function countNewlines(s: string): number {
  let n = 0;
  for (const ch of s) if (ch === '\n') n += 1;
  return n;
}

const DIAG_HEADER = /^main\.swift:(\d+):(\d+): (error|warning|note):/;

/**
 * 補助を付けたときの compile.output を振り分ける（viz-protocol.md §4 後半）。
 * - 行番号が userLineCount 以下の診断はそのまま出す。
 * - 補助の中の warning / note は出さない（続くソース抜粋の行も含めて落とす）。
 * - 補助の中の error は元の診断を残し、最初の 1 つの前に {@link HELPER_CONFLICT_MESSAGE} を添える。
 */
export function filterCompileOutput(
  output: string,
  userLineCount: number,
): { output: string; helperConflict: boolean } {
  const out: string[] = [];
  let keep = true;
  let helperConflict = false;
  for (const line of output.split('\n')) {
    const m = DIAG_HEADER.exec(line);
    if (m) {
      const lineNo = Number(m[1]);
      const severity = m[3];
      if (lineNo <= userLineCount) {
        keep = true;
      } else if (severity === 'error') {
        keep = true;
        if (!helperConflict) out.push(HELPER_CONFLICT_MESSAGE);
        helperConflict = true;
      } else {
        keep = false;
      }
    }
    if (keep) out.push(line);
  }
  return { output: out.join('\n'), helperConflict };
}
